export default __webpack_public_path__ + "static/media/logo_big.becfd945.png";